import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import RadioGroup from './../RadioGroup';
import Toggle from '../Toggle';
import TransomConfigurator from './../TransomConfigurator';
import { withTranslation, Trans } from 'react-i18next';
import { exterior_view01ImageOptions } from './views/exterior_view01'

class XC38Deck extends Component {
    constructor(props) {
        super(props);
        this.handleDeckChange = this.handleDeckChange.bind(this);
        this.handleTeakOnSideDecksChange = this.handleTeakOnSideDecksChange.bind(this);
        this.handleTeakOnCoachroofChange = this.handleTeakOnCoachroofChange.bind(this);
    }
    
    handleDeckChange(newValue) {
        let configuration = this.props.configuration;
        configuration.Deck = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleTeakOnSideDecksChange(event) {
        let configuration = this.props.configuration;
        configuration.TeakOnSideDecks = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleTeakOnCoachroofChange(event) {
        let configuration = this.props.configuration;
        configuration.TeakOnCoachroof = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = exterior_view01ImageOptions;


        let image = (
            <TransomConfigurator colorMultiplier={0.75} name={this.props.transom.Name} port={this.props.transom.Port} transomSize={{ width: 1800, height: 785 }} transform={
                [
                    0.056576, -0.011704, 0, -0.000061,
                    0.011961, 0.097409, 0, 0.000008,
                    0, 0, 1, 0,
                    214, 320, 0, 1
                ]}>
                <ConfiguratorImage boat="XC38" configuration={this.props.configuration} options={imageOptions} />
            </TransomConfigurator>
        );

        return (
            <ConfiguratorSection image={image}>
                
                <ConfiguratorOption>

                    <h1><Trans defaults='Deck & cockpit' /></h1>
                    <p><Trans defaults='Standard on the Xc 38 is genuine teak on cockpit floor and seats. Genuine teak is with black caulkings and optional is Flexiteek finish with grey stripes.' /></p>

                    <RadioGroup label={this.props.t("Deck material:")} options={this.props.deckOptions} value={this.props.configuration.Deck} onChange={this.handleDeckChange} />

                    <h3><Trans defaults='Deck options:' /></h3>

                    <Toggle checked={this.props.configuration.TeakOnSideDecks.value === 2} onChange={this.handleTeakOnSideDecksChange}>
                        <Trans defaults='{{wood}} on side decks' values={{ 'wood': (this.props.configuration.Deck.value === 1) ? 'Teak' : 'Flexiteek' }} />
                    </Toggle>
                    <Toggle checked={this.props.configuration.TeakOnCoachroof.value === 2} onChange={this.handleTeakOnCoachroofChange}>
                        <Trans defaults='{{wood}} on coachroof' values={{ 'wood': (this.props.configuration.Deck.value === 1) ? 'Teak' : 'Flexiteek' }} />
                    </Toggle>

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(XC38Deck);


// WEBPACK FOOTER //
// ./src/XC38/XC38Deck.js